import { TypeConges } from './type-conges';

export class Conges
{
    id: string|undefined;
    dateDebut: string;
    nbreJour: number;
    userName: string;
    annee: string;
    backupUsername: string;
    typeConges: TypeConges;
}